export function Output(props){
return (
    <div id="output">{props.out}</div>
)
}